export default {
  permissions: {
    // Exact match for the raw string from backend in Italian
    'permission name': 'Permission Name Translation',
  },
  roles: {
    role: 'Role Translation',
  }
}
